export const mintExecute = async ({
  contract,
  msg,
}:{
  contract: string,
  msg: string
}) => {
  const res = await window.Wasm.execute(contract, msg, null as any);
  return res;
}

export const queryUserMintInfo = async ({
  collection,
  user,
  contract,
}: {
  collection: number,
  user: string,
  contract: string,
}) => {
  const res = await window.Wasm.query(
    contract,
    JSON.stringify({
      query_user_mint_info: {
        collection,
        user,
      },
    })
  );

  return res;
}

export const queryConfigMintNFT = async ({
  collection,
  contract,
}: {
  collection: number,
  contract: string,
}) => {
  const res = await window.Wasm.query(
    contract,
    JSON.stringify({
      query_config_mint_nft: {
        collection,
      },
    })
  );

  return res;
}

export const getMessageExecuteMint = ({
  contract,
  amount,
  collection,
  totalItem
}:{
  contract: string,
  amount: string,
  collection: number,
  totalItem: string,
}) => {
  return JSON.stringify({
    send: {
      amount,
      contract,
      msg: btoa(
        JSON.stringify({
          mint_nft: {
            collection,
            total_item: totalItem
          }
        })
      )
    }
  });
}

export const getMessageExecuteMintFree = ({
  collection,
  totalItem,
  tokenContract,
  userAddress,
}:{
  collection: number,
  totalItem: string,
  tokenContract: string,
  userAddress: string,
}) => {
  return JSON.stringify({
    round_free_mint: {
      amount_payment: "0",
      collection,
      token: tokenContract,
      total_item: totalItem,
      user: userAddress,
    }
  });
}